import { render } from "./sliders.vue?vue&type=template&id=ea4c8e04"
import script from "./sliders.vue?vue&type=script&lang=js"
export * from "./sliders.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__